import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const ShopPage = lazy(() => import('../pages/shop/page'));
const BlogPage = lazy(() => import('../pages/blog/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const RefundPolicyPage = lazy(() => import('../pages/refund-policy/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/shop',
    element: <ShopPage />,
  },
  {
    path: '/blog',
    element: <BlogPage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/refund-policy',
    element: <RefundPolicyPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
